import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'

const LoginWithEmailUI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
    email, onEmailChange, emailError, setEmailError,
    password, onPasswordChange, passwordError, setPasswordError, showPasswordField
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList}
        buttonMessageKey={`${showPasswordField ? 'c_login' : 'c_next'}`}
        onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
        busy={submitted}>
      <InputTextSF type='text' name='email' required={true} maxLength={64}
        messageList={messageList} labelKey='c_email'
        value={email} onChange={onEmailChange}
        error={emailError} setError={setEmailError}
        autoFocus={!showPasswordField}
      />
      {
        showPasswordField &&
        <InputTextSF type='password' name='password' required={true} maxLength={40}
          messageList={messageList} labelKey='c_password'
          value={password} onChange={onPasswordChange}
          error={passwordError} setError={setPasswordError}
          autoFocus={showPasswordField}
        />
      }
    </FormSF>
    {
      showPasswordField &&
      <div className='passwd'>
        <ButtonLinkUI context={context} messageList={messageList} labelKey='c_forgot_passwd_help'
          to={`/pub/password-help?identity=${email}`}
          transparent={true}
        />
      </div>
    }
  </CardUI>

export default LoginWithEmailUI
